// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__a8E7j","buttons":"SendReceipts_buttons__26hGn","email":"SendReceipts_email__3O4bt","bookApptTitle":"SendReceipts_bookApptTitle__yvtBT"};